<template>
    <div class="mb-1">
        <div
            v-for="option in question.Answers"
            :key="option.strItem"
            class="field"
        >
            <b-checkbox
                v-model="answer"
                size="is-medium"
                type="is-success"
                :native-value="option.strItem"
                @input="onInput"
            >
                {{ option.strItem }}
            </b-checkbox>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        question: {
            type: Object,
            required: true,
        },
    },

    data: function() {
        return {
            answer: [],
        };
    },

    methods: {
        onInput() {
            // emit event to update parent data
            this.$emit('input', this.answer);
        },
    },
};
</script>
